import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { useWebsiteSettings } from 'client/store'
import { AlignType } from 'common/types/styleTypes'
import { getWebsiteStylesTypographyParagraph } from 'src/editor/store/website-settings/website-settings-selector'

export const useHeadingTextAlign = ({
  textAlign,
  mobileTextAlign,
}: {
  textAlign?: AlignType
  mobileTextAlign?: AlignType
}) => {
  const { isMobile } = useDeviceModeContext()
  const { textAlign: globalTextAlign, mobileTextAlign: globalMobileTextAlign } =
    useWebsiteSettings(getWebsiteStylesTypographyParagraph) || {}

  const calculatedTextAlign = isMobile
    ? mobileTextAlign || globalMobileTextAlign
    : textAlign || globalTextAlign

  return {
    calculatedTextAlign,
    globalTextAlign,
    globalMobileTextAlign,
  }
}
